export enum ExportType {
  CANDIDATE = "CANDIDATE",
}

export enum ExportSerializer {
  XLSX = "xlsx",
  CSV = "csv",
}

const ExportSerializerSet = new Set<string>(Object.values(ExportSerializer));
export const isOfTypeExportSerializer = (value: string): value is ExportSerializer => {
  return ExportSerializerSet.has(value);
};
